export function rem2Px(rem: number = 1) {
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  return (htmlWidth / 20) * rem
}

// 处理移动端rem
function setFontSize() {
  const htmlDom = document.querySelector('html')!
  htmlDom.style.fontSize = `${rem2Px()}px`
}

window.addEventListener('resize', setFontSize)

setFontSize()
